<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Tiers'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Tiers'
        };
    },

    computed: {
        labels() {
            return [
                {
                    value: 'stars',
                    width: '150px',
                    type: 'number'
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'tiers/index',
            deleteItem: 'tiers/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/tiers/${id}/edit`);
        },
        onAddButtonClick() {
            this.$router.push('/tiers/add');
        }
    }
};
</script>
